<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[2]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[3]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[4]" />
      </b-col>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[5]" />
      </b-col>

      <b-col v-if="showArea" cols="12" md="3">
        <b-form-group label="เขต" label-for="area">
          <vue-select
            label="text"
            v-model="area"
            :options="areas"
            @input="selectAreaOnInput"
          />
        </b-form-group>
      </b-col>

      <b-col v-if="showProvince" cols="12" md="3">
        <b-form-group label="จังหวัด" label-for="province">
          <vue-select
            label="text"
            v-model="province"
            :options="provinces"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as userData from "@/auth/localStorageUtils.js";
import * as storeMaster from "@/store/api/master/index.js";

import VueSelect from "vue-select";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
    VueSelect,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const areas = [];
    const provinces = [];

    let showArea = true;
    let showProvince = true;

    if (userData.selectedRole() === "f222bebd-9f10-4832-bfdb-18cb0e0311a2") {
      showArea = false;
      showProvince = true;
    }

    if (userData.selectedRole() === "25e8af7c-d072-47fd-985b-fb1eefc44764") {
      showProvince = false;
      showArea = false;
    }

    const searchList = [
      {
        id: "receiveCode",
        label: "เลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกเลขรับแจ้ง / เลขสารบัญ / รหัสติดตามเรื่องหน่วยงานภายนอก",
        type: "text",
        options: [],
      },
      {
        id: "attorneySearch",
        label: "ข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ",
        value: "",
        class: "",
        style: "",
        placeholder: "กรอกข้อมูลผู้ร้องทุกข์ / ผู้มอบอำนาจ",
        type: "text",
        options: [],
      },
      {
        id: "companySearch",
        label:
          "ข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        value: "",
        class: "",
        style: "",
        placeholder:
          "กรอกข้อมูลผู้ถูกร้องทุกข์ / ผู้ประกอบการ  (ชื่อผู้ประกอบการ / เลขนิติบุคคล)",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาที่ร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
      {
        id: "complainDetail",
        label: "รายละเอียดเรื่องร้องทุกข์",
        value: "",
        class: "",
        style: "",
        placeholder: "รายละเอียดเรื่องร้องทุกข์",
        type: "text",
        options: [],
      },
      {
        id: "area",
        label: "เขต",
        value: null,
        class: "",
        style: "",
        placeholder: "เขต",
        type: "bselect",
        options: areas,
      },
      {
        id: "province",
        label: "จังหวัด",
        value: null,
        class: "",
        style: "",
        placeholder: "สถานะดำเนินการ",
        type: "bselect",
        options: provinces,
      },
    ];

    return {
      search: searchList,
      props,
      provinces,
      area: null,
      areas,
      showProvince,
      showArea,
      province: null,
    };
  },
  mounted() {
    this.getAreas();
    if (userData.selectedRole() === "f222bebd-9f10-4832-bfdb-18cb0e0311a2") {
      this.getProvinces(userData.area());
    } else {
      this.getProvinces(null);
    }

    this.onSearchBtnClicked();
  },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
      this.search[2].value = null;
      this.search[3].value = null;
      this.search[4].value = null;
      this.search[5].value = null;
      this.province = null;
      this.area = null;
    },
    onSearchBtnClicked() {
      console.log(
        "user province",
        userData.province(),
        "user area",
        userData.area()
      );
      let paramProvince = null,
        paramArea = null;

      if (userData.selectedRole() === "f222bebd-9f10-4832-bfdb-18cb0e0311a2") {
        paramArea = userData.area();
      } else {
        paramArea = this.area !== null ? this.area.value : null;
      }

      if (userData.selectedRole() === "25e8af7c-d072-47fd-985b-fb1eefc44764") {
        paramProvince = userData.province();
      } else {
        paramProvince = this.province !== null ? this.province.value : null;
      }

      const params = {
        code: this.search[0].value,
        name: this.search[1].value,
        company: this.search[2].value,
        startDate: this.search[3].value,
        endDate: this.search[4].value,
        value: this.search[5].value,
        provinceCode: paramProvince,
        areaCode: paramArea,
      };

      this.$emit("handleSubmit", params);
    },
    getAreas() {
      const _this = this;
      storeMaster
        .getArea()
        .then(function(response) {
          _this.areas = response.data.data;
          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getProvinces(areaCode) {
      const _this = this;

      if (areaCode !== null && areaCode !== undefined) {
        storeMaster
          .getProvinceByArea(areaCode)
          .then(function(response) {
            _this.provinces = response.data.data;
            //_this.province = _this.provinces;
            _this.$forceUpdate();
            console.log("this.provinces", _this.provinces);
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          });
      } else {
        storeMaster
          .getProvince()
          .then(function(response) {
            _this.provinces = response.data.data;
            //_this.province = _this.provinces;
            _this.$forceUpdate();
            console.log("this.provinces", _this.provinces);
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          });
      }
    },
    selectOnInput() {
      console.log("on input");
      this.$forceUpdate();
    },
    selectAreaOnInput() {
      this.getProvinces(this.area.value);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
